<template>
    <section id="section">
        <!--<div class="header pr" :style="`background-image: url('https://img.vhiphop.com/app/cover/${checkCover}.jpg')`">-->
            <div class="header pr" :style="`background-image: url('${up.web_cover}')`">
            <div v-if="id === uid" @click="theme_show = true" @mouseenter="enter" @mouseleave="leave" title="更换皮肤" class="theme-trigger" :style="`background-position: -${position}px 0`"></div>
            <div class="header-bg"></div>
            <div class="header-user df pr">
                <div class="user-brief df">
                    <img :src="up.thumb.replace('http:', 'https:')" class="user-avatar" alt="">
                    <div class="user-basic df">
                        <div class="user-nick">{{up.nico}}</div>
                        <div v-if="id !== uid" class="user-sign">{{up.sign}}</div>
                        <input v-if="id === uid" v-model="up.sign" @change="updateSign" class="user-sign-input" type="text">
                        <input class="input-hidden" type="text">
                    </div>
                </div>
                <!--<div v-if="id !== uid" class="follow-btn">{{followStatus(up.follow_status)}}</div>-->
                <div v-if="id !== uid">
                    <div v-if="!up.follow_status" @click="follow" class="follow-btn">关注</div>
                    <div v-if="up.follow_status === 1" @click="unfollow" class="follow-btn" @mouseenter="hoverText = '取消关注'" @mouseleave="hoverText = ''">{{hoverText || '已关注'}}</div>
                    <div v-if="up.follow_status === 2" @click="unfollow" class="follow-btn" @mouseenter="hoverText = '取消关注'" @mouseleave="hoverText = ''">{{hoverText || '互相关注'}}</div>
                </div>
            </div>
        </div>
        <div :class="`theme-box ${theme_show ? '' : ' theme-box-hidden'}`">
            <div class="theme-main main df">
                <div v-for="v in backgrounds" @click="up.web_cover = v" :class="`theme${up.web_cover === v ? ' check' : ''}`" :style="`background-image: url('${v}')`">
                    <div v-show="up.web_cover === v" class="theme-checked-icon">
                        <i class="icon-success"></i>
                    </div>
                    <div class="theme-tool">
                        免费
                        <div @click="updateCover" class="follow-btn">使用</div>
                    </div>
                </div>
            </div>
            <div @click="closeCover" class="theme-close-box cp">
                <i class="icon-close"></i>
            </div>
        </div>
        <div class="nav df">
            <div class="nav-link-box df pr">
                <router-link :to="`/spaces/${id}`" exact class="nav-link"><i class="icon-home"></i>主页</router-link>
                <router-link :to="`/spaces/${id}/opuses`" class="nav-link"><i class="icon-indite"></i>作品</router-link>
                <!--<router-link :to="`/space/${id}/like`" class="nav-link"><i class="icon-liked"></i>喜欢</router-link>-->
                <router-link :to="`/spaces/${id}/collect`" class="nav-link"><i class="icon-collected"></i>收藏</router-link>
                <router-link v-if="id === uid" :to="`/spaces/${id}/setting`" class="nav-link"><i class="icon-setting"></i>设置</router-link>
                <div class="nav-line"></div>
            </div>
            <div class="df">
                <router-link :to="`/spaces/${id}/follow`" :class="`nav-count nav-count-link${tab.includes('Follow') ? ' active' : ''}`">
                    <div class="nav-count-title">关注数</div>
                    {{up.follows + up.follow_dancers + up.follow_studios}}
                </router-link>
                <router-link :to="`/spaces/${id}/follow/fans`" :class="`nav-count nav-count-link${tab === 'spaceFans' ? ' active' : ''}`">
                    <div class="nav-count-title">粉丝数</div>
                    {{up.fans}}
                </router-link>
                <div class="nav-count">
                    <div class="nav-count-title">播放数</div>
                    {{up.views}}
                </div>
            </div>
        </div>

        <router-view
                :up="up"
                @userIncr="up.follows++"
                @userDecr="up.follows--"
                @dancerIncr="up.follow_dancers++"
                @dancerDecr="up.follow_dancers--"
                @studioIncr="up.follow_studios++"
                @studioDecr="up.follow_studios--"
                @noticeUpdate="e => up.notice = e"
        ></router-view>

    </section>
</template>

<script>
    export default {
        data() {
            return {
                position: 0,
                is_enter: false,
                theme_show: false,
                checkCover: 'https://img.vhiphop.com/web/cover/16.jpg',
                updatedCover: 'https://img.vhiphop.com/web/cover/16.jpg',
                backgrounds: [
                    'https://img.vhiphop.com/web/cover/1.jpg',
                    'https://img.vhiphop.com/web/cover/2.jpg',
                    'https://img.vhiphop.com/web/cover/3.jpg',
                    'https://img.vhiphop.com/web/cover/4.jpg',
                    'https://img.vhiphop.com/web/cover/5.jpg',
                    'https://img.vhiphop.com/web/cover/6.jpg',
                    'https://img.vhiphop.com/web/cover/7.jpg',
                    'https://img.vhiphop.com/web/cover/8.jpg',
                    'https://img.vhiphop.com/web/cover/9.jpg',
                    'https://img.vhiphop.com/web/cover/10.jpg',
                    'https://img.vhiphop.com/web/cover/11.jpg',
                    'https://img.vhiphop.com/web/cover/12.jpg',
                    'https://img.vhiphop.com/web/cover/13.jpg',
                    'https://img.vhiphop.com/web/cover/14.jpg',
                    'https://img.vhiphop.com/web/cover/15.jpg',
                    'https://img.vhiphop.com/web/cover/16.jpg',
                ],
                up: {
                    nico: '',
                    sign: '',
                    notice: '',
                    follow_status: 0,
                    follows: 0,
                    follow_dancers: 0,
                    follow_studios: 0,
                    fans: 0,
                    views: 0,
                    opus: 0,
                    thumb: '',
                },
                hoverText: '',
                is_following: false,
                is_updating: false,
                sign_updating: false,
            }
        },
        methods: {
            async enter() {
                this.is_enter = true;
                while (this.position !== 522 && this.is_enter) {
                    await new Promise(resolve => window.requestAnimationFrame(() => resolve(this.position += 58)));
                }
            },
            async leave() {
                this.is_enter = false;
                while (this.position !== 0 && !this.is_enter) {
                    await new Promise(resolve => window.requestAnimationFrame(() => resolve(this.position -= 58)));
                }
            },
            updateCover() {
                if (this.is_updating) return;
                this.theme_show = false;
                this.is_updating = true;// 开启请求锁

                const {web_cover} = this.up;
                this.api.patch('users/update', {web_cover}).then(() => {
                    this.user.web_cover = this.updatedCover = web_cover;
                    window.localStorage.user = JSON.stringify(this.user);
                    this.is_updating = false;
                }, e => {
                    this.alert.err(e.message);
                    this.is_updating = false;
                });
            },
            updateSign() {
                if (this.sign_updating) return;
                this.sign_updating = true;// 开启请求锁

                const {sign} = this.up;
                this.api.patch('users/update', {sign}).then(() => {
                    this.alert.suc('简介修改成功');
                    this.user.sign = sign;
                    window.localStorage.user = JSON.stringify(this.user);
                    this.sign_updating = false;
                }, e => {
                    this.alert.err(e.message);
                    this.sign_updating = false;
                });
            },
            closeCover() {
                if (this.updatedCover !== this.up.web_cover) {
                    this.confirm({
                        title: '更换头图',
                        content: '您更换的头图尚未保存, 是否保存?',
                        sure: '保存',
                        cancel: '取消保存',
                        sureCb: this.updateCover,
                        cancelCb: () => {
                            this.up.web_cover = this.updatedCover;
                            this.theme_show = false;
                        }
                    });
                } else {
                    this.theme_show = false;
                }

            },
            follow() {
                if (this.is_following) return;
                if (!this.uid) return this.sign.sign_box_show = true;

                this.api.post(`users/${this.id}/follow`).then(e => {
                    this.up.follow_status = e;
                    this.up.fans++;
                    this.following = false;
                }, e => {
                    this.following = false;
                    this.alert.err(e.message);
                });
            },
            unfollow() {
                if (this.following) return;
                if (!this.uid) return this.sign.sign_box_show = true;

                this.confirm({
                    title: '取消关注',
                    content: `确认要取消关注该用户吗?`,
                    sureCb: async () => {
                        this.is_following = true;
                        const {up} = this;
                        up.fans--;
                        up.follow_status = 0;
                        await this.api.del(`users/${this.id}/follow`).catch(e => {
                            up.fans++;
                            this.alert.err(e.message);
                        });
                        this.is_following = false;
                    }
                });
            }
        },

        computed: {
            id() {
                return +this.$route.params.id;
            },
            user() {
                return this.$store.state.user;
            },
            uid() {
                return this.user.id;
            },
            sign() {
                return this.$store.state.sign;
            },
            tab() {
                return this.$route.name
            },
        },
        watch: {
            uid() {
                this.api.get(`dancers/${this.id}/follow`).then(e => {
                    this.is_follow = !!e;
                }, () => {});
            }
        },

        beforeMount() {
            this.api.get(`users/${this.id}/spaces`).then(e => {
                if (e) {
                    e.web_cover = e.web_cover || this.backgrounds[15];
                    this.updatedCover = e.web_cover;
                    this.up = e;
                }
            }, e => this.alert.err(e.message));
        }
    }
</script>

<style scoped>
    @import "../../../static/css/views/space/header.css";
</style>



// WEBPACK FOOTER //
// src/views/space/Header.vue